import {
  createSelector,
  MemoizedSelector
} from '@ngrx/store';

import { State } from '../state';
import { selectState } from './pathways-state.selector';

const getCurationITemId = (state: State): any => state.curationItemId;

export const selectCurationItemId: MemoizedSelector<object, string> = createSelector(
  selectState,
  getCurationITemId);
